export default __webpack_public_path__ + "static/screenThirdSectionRuBig-815d1f5bbe4faa14334c7bc2dc4afa59.webp";